import { LANGUAGES } from "../../costants";
import React, { useEffect, useState } from "react";
import "./bootstrap/bootstrap-landing.css";
import "../../Landing.css";
import { Crosshair, BarChart, Grid as GridIcon, Compass } from 'react-bootstrap-icons';

import logo from "../../images/logos/ecogenius.png";
import ecogenius_icon from "../../images/landing/ecogenius_icon.png";
// import ico_compass from "../../images/landing/ico_compass.png";

import { Grid, Button, Paper, Autocomplete, Divider, styled } from "@mui/material";

// import { ThemeProvider } from "@emotion/react";
// import { createMyTheme } from "../../styles/theme";
// import { useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

//Feb-25
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

export const InfoCard: React.FC = ({}) => {
  // const theme = createMyTheme();
  // const navigate = useNavigate();
  // const location = useLocation();
  const { i18n, t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>();
  
  const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);

  useEffect(() => {
    setCurrentLanguage(i18n.language);
    setSelectedLanguage(i18n.language == "it" ? "Ita" : "Eng");
  }, [i18n.language]);

  const onChangeLang = (code: string, lbl: string) => {
    setSelectedLanguage(lbl);
    i18n.changeLanguage(code);
  };

  const handleNavigateLogin = () => {
    window.location.href = "https://www.openes.io/en/login";
  };

  const handleNavigateRegister = () => {
    window.location.href = "https://www.openes.io/en/signup";
  };

  const scroll = () => {
    const element = document.getElementById('ecogeniusContainer');

    if (element !== null) {
        element.scrollIntoView(true);
    }
  }  

  return (
    <>
    <div className="landingbs">
      <div className="bgLandingHeader pb-5">
        {/* <div className="overlay">
        </div>
      </div> */}
      <div className="landingHeader">
        <Navbar expand="lg" className="landingNavbar navbar-dark">
          <Container>
            <Navbar.Brand href="#home">
              <img src={ecogenius_icon} alt="EcoGenius Logo" style={{ height: "60px" }} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto text-center">
                <Nav.Link href="mailto:info@openes.io"><Trans i18nKey="lblContattaci"/></Nav.Link>
                <Nav.Link className="button white" onClick={handleNavigateRegister}><Trans i18nKey="lblRegistrati"/></Nav.Link>
                <Nav.Link className="button" onClick={handleNavigateLogin}><Trans i18nKey="lblAccedi"/></Nav.Link>
                <NavDropdown title={selectedLanguage} id="basic-nav-dropdown">
                { LANGUAGES.map((language) => (
                  <NavDropdown.Item className="text-center" style={{color: "#ffffff"}} onClick={() => onChangeLang(language.code, language.lbl)}>{language.label}</NavDropdown.Item>
                ))}
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Row className="mx-0 text-center">
          <Col className="d-flex justify-content-center">
            <Row className="headerContent">
              <h1>Open-es ECOgenius</h1>
              <Col></Col>
              <Col className="text-center landingSection sectionHeader stack-vertical" xs={7}>
                <h5><Trans i18nKey="lblHeaderSottotitolo"/></h5>
                <button onClick={scroll}><Trans i18nKey="lblHeaderButton"/></button>
                <div className="greaterIcon" onClick={scroll}><span className="grey">&gt;</span>&gt;</div>
              </Col>
              <Col></Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
      <Container fluid className="ecoGeniusLanding" id="ecogeniusContainer">
          <Row>
            <Col></Col>
            <Col className="text-center landingSection sectionHeader" xs={8}>
              <h2 className="pb-2">
                <Trans i18nKey="lblSectionCaratteristicheTitle" />
              </h2>
              <p style={{ marginBottom: "4rem" }}>
                <Trans i18nKey="lblSottotitoloCaratteristiche" />
              </p>
            </Col>
            <Col></Col>
          </Row>

          <Row>
            <Col className="d-flex justify-content-center">
              <Row className="rowCaratteristiche g-4 pb-4 mx-5 row-cols-1 row-cols-md-2 row-cols-lg-4">
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche immagine" id="imgCaratteristiche1"></div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche" id="txtCaratteristiche1">
                    <p className="title"><Trans i18nKey="lblBoxCaratteristiche1Title"/></p>
                    <p className="testo"><Trans i18nKey="lblBoxCaratteristiche1Testo"/></p>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche immagine" id="imgCaratteristiche2"></div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche" id="txtCaratteristiche2">
                    <p className="title"><Trans i18nKey="lblBoxCaratteristiche2Title"/></p>
                    <p className="testo"><Trans i18nKey="lblBoxCaratteristiche2Testo"/></p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <Row className="rowCaratteristiche g-4 mx-5 row-cols-1 row-cols-md-2 row-cols-lg-4">
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche" id="txtCaratteristiche4">
                    <p className="title"><Trans i18nKey="lblBoxCaratteristiche4Title"/></p>
                    <p className="testo"><Trans i18nKey="lblBoxCaratteristiche4Testo"/></p>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche immagine" id="imgCaratteristiche4"></div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche" id="txtCaratteristiche3">
                    <p className="title"><Trans i18nKey="lblBoxCaratteristiche3Title"/></p>
                    <p className="testo"><Trans i18nKey="lblBoxCaratteristiche3Testo"/></p>
                  </div>
                </Col>
                <Col className="d-flex justify-content-center">
                  <div className="boxCaratteristiche immagine" id="imgCaratteristiche3"></div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col></Col>
            <Col className="text-center landingSection sectionHeader" xs={8}>
              <h2 className="pb-2"><Trans i18nKey="lblSectionCarbonTitleP1"/><br/>
              <Trans i18nKey="lblSectionCarbonTitleP2"/></h2>
              <p className="pb-2"><Trans i18nKey="lblSectionCarbonSottotitoloP1"/><b> <Trans i18nKey="lblSectionCarbonSottotitoloP2"/></b><Trans i18nKey="lblSectionCarbonSottotitoloP3"/></p>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center">
              <Row className="rowCarbonEstimator g-4 py-5 mx-5 row-cols-1 row-cols-md-2 row-cols-lg-4">
                <Col>
                  <div className="boxCarbonIcon" id="icoEstimator1">
                    <Row className="rowCarbonIcon">
                      <Col className="col-lg-12 d-flex justify-content-center pb-2">
                          <BarChart color="#ffffff" size={40} className="align-self-center"/>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator immagine" id="imgEstimator1"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator" id="txtEstimator1">
                        <p className="title"><Trans i18nKey="lblBoxCarbon1Title"/></p>
                        <p className="testo"><Trans i18nKey="lblBoxCarbon1Testo"/></p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <div className="boxCarbonIcon" id="icoEstimator2">
                    <Row className="rowCarbonIcon">
                      <Col className="col-lg-12 d-flex justify-content-center pb-3">
                          <Compass color="#ffffff" size={40} className="align-self-center"/>
                          {/* <img className="align-self-center" src={ico_compass} width="40" height="40" /> */}
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator immagine" id="imgEstimator2"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator" id="txtEstimator2">
                        <p className="title"><Trans i18nKey="lblBoxCarbon2Title"/></p>
                        <p className="testo"><Trans i18nKey="lblBoxCarbon2Testo"/></p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <div className="boxCarbonIcon" id="icoEstimator3">
                    <Row className="rowCarbonIcon">
                      <Col className="col-lg-12 d-flex justify-content-center pb-2">
                          <Crosshair color="#000000" size={40} className="align-self-center"/>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator immagine" id="imgEstimator3"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator" id="txtEstimator3">
                        <p className="title"><Trans i18nKey="lblBoxCarbon3Title"/></p>
                        <p className="testo"><Trans i18nKey="lblBoxCarbon3Testo"/></p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <div className="boxCarbonIcon" id="icoEstimator4">
                    <Row className="rowCarbonIcon">
                      <Col className="col-lg-12 d-flex justify-content-center pb-2">
                          <GridIcon color="#ffffff" size={40} className="align-self-center"/>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator immagine" id="imgEstimator4"></div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="boxCarbonEstimator" id="txtEstimator4">
                        <p className="title"><Trans i18nKey="lblBoxCarbon4Title"/></p>
                        <p className="testo"><Trans i18nKey="lblBoxCarbon4Testo"/></p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="text-center landingSection landingFooter">
              <Row>
                <Col>
                  <h2 className="pb-2"><Trans i18nKey="lblSectionFooterTitle"/></h2>
                  <p className="pb-2"><Trans i18nKey="lblSectionFooterSottotitolo"/></p>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Button className="white no-uppercase" onClick={handleNavigateRegister}><Trans i18nKey="lblRegistrati"/></Button>
                </Col>
                <Col className="text-start">
                  <Button onClick={handleNavigateLogin} className="no-uppercase"><Trans i18nKey="lblAccedi"/></Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
